import type { Routes } from '@angular/router';
import {
  AppActions,
  AppFeature,
  getClaimString,
} from '../../shared/constants/app-claims';

export const FLEET_MANAGEMENT_ROUTES: Routes = [
  {
    path: 'captains',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesCaptains, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/captains/captains-component').then(
        m => m.CaptainsComponent
      ),
  },
  {
    path: 'captains/create',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesCaptains, AppActions.Create),
      ],
    },
    loadComponent: () =>
      import(
        './components/captains/components/create-captain/create-captain.component'
      ).then(m => m.CreateCaptainComponent),
  },
  {
    path: 'captains/:id',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesCaptains, AppActions.Update),
      ],
    },
    loadComponent: () =>
      import(
        './components/captains/components/edit-captain/edit-captain.component'
      ).then(m => m.EditCaptainComponent),
  },
  {
    path: 'species',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesSpecies, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/species/species-component').then(
        m => m.SpeciesComponent
      ),
  },
  {
    path: 'species/create',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesSpecies, AppActions.Create),
      ],
    },
    loadComponent: () =>
      import(
        './components/species/components/create-specie/create-specie.component'
      ).then(m => m.CreateSpecieComponent),
  },
  {
    path: 'species/:id',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesSpecies, AppActions.Update),
      ],
    },
    loadComponent: () =>
      import(
        './components/species/components/update-specie/update-specie.component'
      ).then(m => m.UpdateSpecieComponent),
  },
  {
    path: 'vessels',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesShips, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/vessels/vessels-component').then(
        m => m.VesselsComponent
      ),
  },
  {
    path: 'ports',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesPorts, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/ports/ports.component').then(m => m.PortsComponent),
  },
  {
    path: 'docks',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesDocks, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/docks/docks.component').then(m => m.DocksComponent),
  },
  {
    path: 'docks/update/:id',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesDocks, AppActions.Update),
      ],
    },
    loadComponent: () =>
      import(
        './components/docks/components/update-dock/update-dock.component'
      ).then(m => m.UpdateDockComponent),
  },
  {
    path: 'docks/create',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesDocks, AppActions.Create),
      ],
    },
    loadComponent: () =>
      import(
        './components/docks/components/create-dock/create-dock.component'
      ).then(m => m.CreateDockComponent),
  },
  {
    path: 'coast-guards',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesCoastGuards, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/coast-guards/coast-guards.component').then(
        m => m.CoastGuardComponent
      ),
  },
  {
    path: 'inspectors',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesInspectors, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/inspectors/inspectors.component').then(
        m => m.InspectorsComponent
      ),
  },
  {
    path: 'ship-owners',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesShipOwners, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/ship-owners/ship-owners.component').then(
        m => m.ShipOwnersComponent
      ),
  },
  {
    path: 'biologists',
    data: {
      claims: [
        getClaimString(AppFeature.ReferenceTablesBiologists, AppActions.Read),
      ],
    },
    loadComponent: () =>
      import('./components/biologists/biologists.component').then(
        m => m.BiologistsComponent
      ),
  },
];
